import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'

import styled from 'styled-components'

import { rhythm } from '../utils/typography'
import gray from 'gray-percentage'

const PageLink = styled(props => 
  <h1 className={props.className}>
    <Link to={props.to}>
      {props.children}
    </Link>
  </h1>
)`
  a {
    text-decoration: none;
    color: #72a0c1;

    &:hover {
      color: #9cbcd3;
    }
  }
`

const BlogListContainer = styled.div`
  max-width: 30rem;
  padding: 1rem;
`

class BlogIndex extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const posts = get(this, 'props.data.allMarkdownRemark.edges')

    return (
      <BlogListContainer>
        <Helmet title={siteTitle} />
        {posts.map(({ node }) => {
          const title = get(node, 'frontmatter.title') || node.fields.slug
          return (
            <div key={node.fields.slug}>
              <PageLink to={node.fields.slug}>
                  {title}
              </PageLink>
              <small>{node.frontmatter.date}</small>
              <p dangerouslySetInnerHTML={{ __html: node.excerpt }} />
            </div>
          )
        })}
      </BlogListContainer>
    )
  }
}

export default BlogIndex

exports.frontmatter = {
  title: "Posts",
  inChilly: true
}

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD MMMM, YYYY")
            title
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/posts.js